import(/* webpackMode: "eager" */ "/opt/trendrain/trendrain-web/src/app/recipes/page.tsx");
